import { ApiInstance } from './base'

const InventoryService = {
    getInventoryList(params) {
        return ApiInstance.get('/inventory/list', { params })
    },
    downloadLabels(payload) {
        return ApiInstance.post('/inventory/download-labels', payload)
    },
    getExpenses(id) {
        return ApiInstance.get(`/inventory/${id}/expenses`)
    },
    createExpenses(id, payload) {
        return ApiInstance.post(`/inventory/${id}/expenses`, payload)
    },
    createFilter(payload) {
        return ApiInstance.post('/inventory/filter/create', payload)
    },
    updateFilter(id, payload) {
        return ApiInstance.patch(`/inventory/filter/${id}`, payload)
    },
    deleteFilter(id) {
        return ApiInstance.delete(`/inventory/filter/${id}`)
    },
    getFilters() {
        return ApiInstance.get('/inventory/filter')
    },
    getFilter(id) {
        return ApiInstance.get(`/inventory/filter/${id}`)
    },
    applyFilter(payload, params) {
        const queryString = params ? `?${new URLSearchParams(params).toString()}` : ''
        return ApiInstance.post(`/inventory/filter${queryString}`, payload)
    },
    filterSort(payload) {
        return ApiInstance.post('/inventory/filter/sort', payload)
    },
    getCategories() {
        return ApiInstance.get('/inventory/categories')
    },
    getDetail(id) {
        return ApiInstance.get(`/inventory/${id}/detail`)
    },
    deleteProduct(id) {
        return ApiInstance.delete(`/inventory/${id}/remove`)
    },
    addToRestrictedProduct(id) {
        return ApiInstance.post(`/inventory/${id}/add-to-restricted-product`)
    },
    addToRestrictedBrand(id) {
        return ApiInstance.post(`/inventory/${id}/add-to-restricted-brand`)
    },
    variationScan(id, payload) {
        return ApiInstance.post(`/inventory/${id}/variation-scan`, payload)
    },
    getOffers(id) {
        return ApiInstance.get(`/inventory/${id}/offers`)
    },
    getSupply(id) {
        return ApiInstance.get(`/inventory/${id}/supply`)
    },
    addSupply(id, payload) {
        return ApiInstance.post(`/inventory/${id}/add-supply`, payload)
    },
    editSupply(id, index, payload) {
        return ApiInstance.post(`/inventory/${id}/edit-supply/${index}`, payload)
    },
    deleteSupply(id, index) {
        return ApiInstance.post(`/inventory/${id}/delete-supply/${index}`)
    },
    addNote(id, payload) {
        return ApiInstance.post(`/inventory/${id}/add-note`, payload)
    },
    getPastOrders(id, params) {
        return ApiInstance.get(`/inventory/${id}/orders`, { params })
    },
    getKeepa(id, params) {
        return ApiInstance.get(`/inventory/${id}/keepa`, params)
    },
    setCalculate(id, payload) {
        return ApiInstance.post(`/inventory/${id}/calculate`, payload)
    },
    getCurrentCalculate(id, payload) {
        return ApiInstance.post(`/inventory/${id}/calculate/current`, payload)
    },
    getStats(date) {
        return ApiInstance.get(`/inventory/stats?dateRange=${date}`)
    },
    getOutOfStock(params) {
        return ApiInstance.get('/inventory/out-of-stock', { params })
    },
    getBestSellers() {
        return ApiInstance.get('/inventory/best-sellers')
    },
    getWithoutCog(params) {
        return ApiInstance.get('/inventory/without-cog', { params })
    },
    addToInventoryByAsin(asin) {
        return ApiInstance.get(`/inventory/add-to-inventory?asin=${asin}`)
    },
    addToInventory(payload) {
        return ApiInstance.post('/inventory/add-to-inventory', payload)
    },
    sendToScan(payload) {
        return ApiInstance.post('/inventory/scan', payload)
    },
    removeProducts(payload) {
        return ApiInstance.post('/inventory/remove', payload)
    },
    removeRestrictedProduct(id) {
        return ApiInstance.post(`/inventory/${id}/remove-restricted-product`)
    },
    removeRestrictedBrand(id) {
        return ApiInstance.post(`/inventory/${id}/remove-restricted-brand`)
    },
    getLocationStats(params) {
        return ApiInstance.get('/inventory/location-stats', { params })
    },
    getSalesVelocity(params) {
        return ApiInstance.get('/inventory/sales-velocity', { params })
    },
    bulkCostCreate(payload) {
        return ApiInstance.post('/inventory/bulk-expenses', payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    },
    getBulkCostProcess() {
        return ApiInstance.get('/inventory/bulk-expenses/process')
    },
    checkBulkCostProcess(id) {
        return ApiInstance.post(`/inventory/bulk-expenses/process/${id}`)
    },
    getBulkCostTemplate() {
        return ApiInstance.get('/inventory/bulk-expenses/template')
    },
}

export default InventoryService
